// extracted by mini-css-extract-plugin
module.exports = {"serviceAccordionWrapper":"ServiceAccordion_serviceAccordionWrapper__P_ihb","divider":"ServiceAccordion_divider__eMOUU"};